import React, { useState, useEffect } from 'react';
import { Table, Button, Typography, Input } from 'antd';

const { Title } = Typography;

export const ArticulosStep = ({
  articulosCliente,
  selectedItems,
  setSelectedItems,
  setModalVisible,
  setCurrentArticulo,
  setPosicionesSeleccionadas,
}) => {
  const [filteredArticulos, setFilteredArticulos] = useState(articulosCliente);
  const [searchFilters, setSearchFilters] = useState({});

  useEffect(() => { applyFilters(); }, [searchFilters, articulosCliente]);

  const applyFilters = () => {
    const filtered = articulosCliente.filter((articulo) =>
      Object.keys(searchFilters).every((key) => {
        const value = articulo[key];
        return value?.toString().toLowerCase().includes(searchFilters[key]?.toLowerCase());
      })
    );
    setFilteredArticulos(filtered);
  };

  const handleSearch = (key, value) => setSearchFilters(prev => ({ ...prev, [key]: value }));

  const openPosicionesModal = (record) => {
    // APLANA posiciones -> filas por posición + lote + vencimiento
    const rows = (record.posiciones || []).flatMap((pos) => {
      const hasLotes = Array.isArray(pos.lotes) && pos.lotes.length;
      if (!hasLotes) {
        return [{
          key: `${pos.posicion}-nl-nf`,
          posicion: pos.posicion,
          lote: null,
          fechaVencimiento: null,
          cantidad: pos.cantidad,
          cantidadRetirar: 0,
        }];
      }
      return pos.lotes.map((l) => ({
        key: `${pos.posicion}-${l.lote || 'nl'}-${l.fechaVencimiento || 'nf'}`,
        posicion: pos.posicion,
        lote: l.lote ?? null,
        fechaVencimiento: l.fechaVencimiento ?? null,
        cantidad: l.cantidad,
        cantidadRetirar: 0,
      }));
    });

    setCurrentArticulo(record);
    setPosicionesSeleccionadas(rows);
    setModalVisible(true);
  };

  const columns = [
    {
      title: 'Artículo',
      dataIndex: 'nombreArticulo',
      key: 'nombreArticulo',
      filterDropdown: () => (
        <Input placeholder="Buscar Artículo" onChange={(e) => handleSearch('nombreArticulo', e.target.value)} style={{ marginBottom: 8 }} />
      ),
    },
    {
      title: 'Marca',
      dataIndex: 'marca',
      key: 'marca',
      filterDropdown: () => (
        <Input placeholder="Buscar Marca" onChange={(e) => handleSearch('marca', e.target.value)} style={{ marginBottom: 8 }} />
      ),
    },
    {
      title: 'Categoría',
      dataIndex: 'categoria',
      key: 'categoria',
      filterDropdown: () => (
        <Input placeholder="Buscar Categoría" onChange={(e) => handleSearch('categoria', e.target.value)} style={{ marginBottom: 8 }} />
      ),
    },
    { title: 'Unidad de Medida', dataIndex: 'unidadDeMedida', key: 'unidadDeMedida' },
    { title: 'Cantidad Disponible', dataIndex: 'cantidadDisponible', key: 'cantidadDisponible', render: (cantidad) => Number(cantidad).toFixed(2) },
    {
      title: 'Acciones',
      render: (_, record) => (
        <Button type="primary" onClick={() => openPosicionesModal(record)}>
          Seleccionar
        </Button>
      ),
    },
  ];

  return (
    <>
      <Title level={4}>Artículos del Cliente</Title>
      <Table
        dataSource={filteredArticulos}
        columns={columns}
        rowKey={(r) => r?.articulo?._id || r?.nombreArticulo}
        pagination={{ pageSize: 5 }}
      />

      <Title level={4}>Artículos Seleccionados</Title>
      <Table
        dataSource={selectedItems}
        columns={[
          { title: 'Artículo', dataIndex: 'nombreArticulo', key: 'nombreArticulo' },
          {
            title: 'Posiciones / Lotes seleccionados',
            render: (_, record) => (
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                {(record.posiciones || []).map((p, idx) => (
                  <li key={`${p.posicion}-${idx}`}>
                    <strong>{p.posicion}</strong>
                    <ul style={{ marginTop: 4 }}>
                      {(p.lotes || []).map((l, j) => (
                        <li key={`${p.posicion}-l-${j}`}>
                          Lote: {l.lote || '—'} · Venc.: {l.fechaVencimiento ? new Date(l.fechaVencimiento).toISOString().slice(0,10) : '—'} · Retirar: {Number(l.cantidadRetirar || 0).toFixed(2)}
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            ),
          },
        ]}
        rowKey={(r) => r?.articulo?._id || r?.nombreArticulo}
        pagination={{ pageSize: 5 }}
      />
    </>
  );
};